// extracted by mini-css-extract-plugin
export default {"list-item":"ManageCard_list-item__1ZXtX"};